<template>
  <div>
    <!-- 活动详情弹窗 -->
    <div class="popup_wrap1 logout-wrap" v-show="isShowActivityDetail">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="activity-detail">
          <div class="title"></div>
          <div class="detail">
            <img
              src="https://download4.qcplay.com/h5-images/active/hjwq/anniversary/dialog/detail.png"
              alt=""
            />
          </div>
          <div class="btn" @click="isShowActivityDetail = false"></div>
          <div class="close-btn" @click="isShowActivityDetail = false"></div>
        </div>
      </transition>
      <div
        class="close-bg"
        v-show="isShowActivityDetail"
        @click.stop="isShowActivityDetail = false"
      ></div>
    </div>
    <!-- 分享报告弹窗 -->
    <div
      class="popup_wrap1 logout-wrap animated fadeIn"
      v-show="isShowShareDialog"
    >
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="share-dialog">
          <div :class="roleClass()" v-if="activity.play_info"></div>
          <div class="name">
            ID：{{ userInfo.server_name }} {{ userInfo.role_name }}
          </div>
          <div class="five_dimensions_wrap">
            <div
              class="five_dimensions"
              id="five-dimensions-dialog"
              style="width: 100%; height: 100%"
            ></div>
          </div>
          <div class="info" v-if="activity.play_info">
            <div :class="designationClass()"></div>
            <div class="designation_btn" @click="isShowTapDialog = true"></div>
            <div class="times">
              <p>
                您于<span>{{
                  formatDate(activity.play_info.registerdate)
                }}</span
                >来到仙剑世界<br />总在线时长达<span>{{
                  formatNumberWithCommas(activity.play_info.onlinehours)
                }}</span
                >小时
              </p>
            </div>
            <div class="jinlong">
              ×{{ formatNumberWithCommas(activity.play_info.diamondconsume) }}
            </div>
            <div class="tili">
              ×{{ formatNumberWithCommas(activity.play_info.vitconsume) }}
            </div>
            <div class="qiyuanfu">
              ×{{ formatNumberWithCommas(activity.play_info.qiyuanfuconsume) }}
            </div>
            <div class="wuxishi">
              ×{{ formatNumberWithCommas(activity.play_info.wuxizhaoconsume) }}
            </div>
            <div class="xiyouxiake">
              ×{{ formatNumberWithCommas(activity.play_info.recruitxiyou) }}
            </div>
            <div class="yinyangxiake">
              ×{{ formatNumberWithCommas(activity.play_info.recruityinyang) }}
            </div>
          </div>
          <div class="clouding"></div>
          <div class="share_btn" @click="isShowShareImg"></div>
          <div class="tips"></div>
        </div>
      </transition>
      <div class="close-bg" v-show="isShowShareDialog"></div>
    </div>
    <!-- 分享报告弹窗(没有数据) -->
    <div
      class="popup_wrap1 logout-wrap animated fadeIn"
      v-show="isShowShareDialog1"
    >
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="share-nodata-dialog">
          <div class="code"></div>
          <div class="clouding"></div>
          <div class="share_btn" @click="isShowShareImg"></div>
        </div>
      </transition>
      <div class="close-bg" v-show="isShowShareDialog1"></div>
    </div>
    <!-- 标签弹窗 -->
    <div class="popup_wrap1 logout-wrap" v-show="isShowTapDialog">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="describe-dialog">
          <div class="title"></div>
          <div class="describe1_wrap" v-if="isShowDescribe1">
            <div
              :class="'describe1_' + index"
              v-for="index in 6"
              :key="index"
              @click="describeIndex = index"
            >
              <div class="checked" v-if="index == describeIndex"></div>
            </div>
          </div>
          <div class="describe2_wrap" v-if="isShowDescribe2">
            <div
              :class="'describe2_' + index"
              v-for="index in 5"
              :key="index"
              @click="describeIndex = index"
            >
              <div class="checked" v-if="index == describeIndex"></div>
            </div>
          </div>
          <div class="describe3_wrap" v-if="isShowDescribe3">
            <div
              :class="'describe3_' + index"
              v-for="index in 4"
              :key="index"
              @click="describeIndex = index"
            >
              <div class="checked" v-if="index == describeIndex"></div>
            </div>
          </div>
          <div class="describe4_wrap" v-if="isShowDescribe4">
            <div
              :class="'describe4_' + index"
              v-for="index in 3"
              :key="index"
              @click="describeIndex = index"
            >
              <div class="checked" v-if="index == describeIndex"></div>
            </div>
          </div>
          <div class="describe-btn" @click="describeConfirm"></div>
          <div class="close-btn" @click="closeTapDialog"></div>
        </div>
      </transition>
      <div class="close-bg"></div>
    </div>
    <!-- 查找仙盟弹窗 -->
    <div class="popup_wrap1 logout-wrap" v-show="isShowSectDialog">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="sect-dialog">
          <div class="title"></div>
          <div class="wrap">
            <div class="serverNameWrap">
              <span>大区</span>
              <select
                name="public-choice"
                v-model="serverName"
                @focus="inputFocus()"
                @focusout="inputFocusOut"
              >
                <option
                  :value="serverItem.id"
                  v-for="serverItem in serverNameList"
                  :key="serverItem.id"
                >
                  {{ serverItem.name }}
                </option>
              </select>
            </div>
            <div class="xmWrap">
              <span>仙盟名</span>
              <input
                name="public-choice"
                v-model="xmName"
                @focus="inputFocus()"
                @focusout="inputFocusOut"
              />
            </div>
          </div>
          <div class="btn" @click="getSectClick"></div>
          <div class="close-btn" @click="isShowSectDialog = false"></div>
        </div>
      </transition>
      <div class="close-bg"></div>
    </div>
    <!-- 分享成功弹窗 -->
    <div class="popup_wrap1 logout-wrap" v-show="isShowShareSuccess">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="share-success-dialog">
          <div class="title"></div>
          <div class="btn" @click="isShowShareSuccessClick"></div>
          <div class="close-btn" @click="isShowShareSuccessClick"></div>
        </div>
      </transition>
      <div class="close-bg"></div>
    </div>
  </div>
</template>
<script>
import { Indicator } from "mint-ui";
export default {
  data() {
    return {
      // 活动详情弹窗
      isShowActivityDetail: false,
      // 分享报告弹窗
      isShowShareDialog: false,
      // 分享弹窗（没有数据）
      isShowShareDialog1: false,
      // 分享成功弹窗
      isShowShareSuccess: false,
      // 标签弹窗
      isShowTapDialog: false,
      // 标签档次
      isShowDescribe1: false,
      isShowDescribe2: false,
      isShowDescribe3: false,
      isShowDescribe4: false,
      // 标签选择
      describeIndex: 1,
      // 选择的标签（未确定）
      describeIndex1: 1,
      // 查找仙盟弹窗
      isShowSectDialog: false,
      // 活动信息
      activity: "",
      // 用户信息
      userInfo: "",
      timer: null,
      // 服务器
      serverName: "qf",
      serverNameList: [
        { id: "qf", name: "全服" },
        { id: "qcplay", name: "官方正式服" },
        { id: "gzf", name: "光子服" },
        { id: "qdf", name: "渠道正式服" },
        { id: "bilibili", name: "BiliBili服" },
        { id: "qdxqf", name: "渠道先遣服" },
        { id: "79xqf", name: "79先遣服" },
      ],
      // 仙盟名
      xmName: "",
    };
  },
  created() {},
  mounted() {},
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (newValue.role_id != oldValue.role_id) {
          this.fiveDimensionalTitle();
          setTimeout(() => {
            this.echartsInit();
          }, 500);
        }
      },
      deep: true,
    },
  },
  methods: {
    // 移动端键盘调用
    inputFocus() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
    inputFocusOut() {
      this.timer = setTimeout(() => {
        window.scrollTo(0, 0);
      }, 10);
    },
    // 获取查询仙盟的参数
    getSectClick() {
      this.isShowSectDialog = false;
      this.$emit("getTeamData", this.serverName, this.xmName);
      this.xmName = "";
    },
    // 五维图初始化
    echartsInit() {
      const echarts = window.echarts || echarts;
      const chartDom = document.getElementById("five-dimensions-dialog");
      const myChart = echarts.init(chartDom);
      const option = {
        color: ["#96cce2"],
        radar: {
          splitNumber: 1,
          indicator: [
            { name: "", max: 5 },
            { name: "", max: 5 },
            { name: "", max: 5 },
            { name: "", max: 5 },
            { name: "", max: 5 },
          ],
          textStyle: {
            color: "#96cce2",
            fontWeight: "bold",
            fontSize: 30,
            fontFamily: "hjwq",
          },
          axisLine: {
            lineStyle: {
              color: "#96cce2",
              width: 1.1,
            },
          },
          splitLine: {
            lineStyle: {
              color: "#96cce2",
              width: 1.1,
            },
          },
          splitArea: {
            areaStyle: {
              color: "transparent",
            },
          },
          center: ["50%", "50%"],
          radius: "100%",
        },
        series: [
          {
            name: "ability",
            type: "radar",
            symbol: "none",
            data: [
              {
                value: [
                  this.fiveDimensionalValue(this.activity.max_fap_proportion),
                  this.fiveDimensionalValue(this.activity.maxlayerid),
                  this.fiveDimensionalValue(
                    this.activity.diamondconsume_proportion
                  ),
                  this.fiveDimensionalValue(this.activity.equipnum),
                  this.fiveDimensionalValue(this.activity.CurScore),
                ],
                name: "ability-radar",
                areaStyle: {
                  color: "#fff4cc",
                },
              },
            ],
          },
        ],
      };
      myChart.setOption(option);
    },
    // 计算五位图数值
    fiveDimensionalValue(value) {
      let text = 0;
      if (value >= 95) {
        text = 5;
      } else if (65 <= value && value < 95) {
        text = 4.5;
      } else if (35 <= value && value < 65) {
        text = 4;
      } else if (15 <= value && value < 35) {
        text = 3.5;
      } else if (value < 15) {
        text = 3;
      }
      return text;
    },
    // 计算五位图数值显示称号
    fiveDimensionalTitle() {
      this.isShowDescribe1 = false;
      this.isShowDescribe2 = false;
      this.isShowDescribe3 = false;
      this.isShowDescribe4 = false;
      const list = [
        this.activity.max_fap_proportion,
        this.activity.maxlayerid,
        this.activity.diamondconsume_proportion,
        this.activity.equipnum,
        this.activity.CurScore,
      ];
      // 使用filter方法筛选出大于95的数
      const greaterThan95 = list.filter((number) => number >= 95);
      const greaterThan65 = list.filter((number) => number >= 65);
      const greaterThan35 = list.filter((number) => number >= 35);
      if (greaterThan95.length > 2) {
        this.describeIndex1 = Math.floor(Math.random() * 6) + 1;
        this.describeIndex = this.describeIndex1;
        this.isShowDescribe1 = true;
      } else if (greaterThan65.length > 2) {
        this.describeIndex1 = Math.floor(Math.random() * 5) + 1;
        this.describeIndex = this.describeIndex1;
        this.isShowDescribe2 = true;
      } else if (greaterThan35.length >= 2) {
        this.describeIndex1 = Math.floor(Math.random() * 4) + 1;
        this.describeIndex = this.describeIndex1;
        this.isShowDescribe3 = true;
      } else {
        this.describeIndex1 = Math.floor(Math.random() * 3) + 1;
        this.describeIndex = this.describeIndex1;
        this.isShowDescribe4 = true;
      }
    },
    // 分享成功弹窗
    isShowShareSuccessClick() {
      this.isShowShareSuccess = false;
      this.$emit("getLoginContainer");
    },
    // 分享弹窗标签class判断
    designationClass() {
      let designation = "designation ";
      for (let i = 1; i <= 4; i++) {
        if (this[`isShowDescribe${i}`]) {
          return `${designation}designation_${i}_${this.describeIndex1}`;
        }
      }
    },
    // 修改称号更换角色
    roleClass() {
      if (this.isShowDescribe1) {
        if (this.activity.play_info.Gender == 0) {
          return "role role_1_" + this.describeIndex1;
        } else {
          return "role role_1_" + (this.describeIndex1 + 6);
        }
      } else if (this.isShowDescribe2) {
        if (this.activity.play_info.Gender == 0) {
          return "role role_2_" + this.describeIndex1;
        } else {
          return "role role_2_" + (this.describeIndex1 + 5);
        }
      } else if (this.isShowDescribe3) {
        if (this.activity.play_info.Gender == 0) {
          return "role role_3_" + this.describeIndex1;
        } else {
          return "role role_3_" + (this.describeIndex1 + 4);
        }
      } else if (this.isShowDescribe4) {
        return "role role_4_" + this.describeIndex1;
      }
    },
    // 修改标签的方法
    describeConfirm() {
      this.isShowTapDialog = false;
      this.describeIndex1 = this.describeIndex;
      Indicator.open();
      this.$emit("initShareData");
    },
    // 关闭标签弹窗（未修改）
    closeTapDialog() {
      this.isShowTapDialog = false;
      this.describeIndex = this.describeIndex1;
    },
    isShowShareImg() {
      this.$emit("isShowShareImg");
    },
    // 时间转年月日
    formatDate(time) {
      if (!time) {
        return;
      }
      let date = new Date(time * 1000);
      // 获取年、月、日
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; // 月
      let day = date.getDate(); // 日
      // 组合成最终的格式
      let formattedDate = `${year}年${month}月${day}日`;
      return formattedDate;
    },
    // 数字转换
    formatNumberWithCommas(str) {
      if (!str) {
        return "0";
      }
      // 使用正则表达式将字符串从右向左每三个数字分组，并在组之间插入逗号
      return str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style lang="less" scope>
@import url("./index.less");

.five_dimensions {
  div {
    width: 100% !important;
    height: 100% !important;
    canvas {
      width: 100% !important;
      height: 100% !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/hjwq/anniversary/components/dialog.vue